import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion";

const AccordionItem = ({ title, content, isOpen, onClick }) => {
  return (
    <div className="rewamp-accordian">
      <button
        className="accordian-title"
        onClick={onClick}
        style={{
          width: "100%",
          textAlign: "left",
          padding: "10px",
          background: "transparent",
          border: "none",
          cursor: "pointer",
        }}
      >
        <i className={`accordian-icon fa-solid fa-plus ${isOpen ? "rotate" : ""}`}></i>{title}
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            style={{ overflow: "hidden" }}
          >
            <div className="accordian-content">{content}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default AccordionItem;